import { FragmentType, gql, useFragment } from '@/__generated__';
import React, { useState } from 'react';
import { AssetsType } from '@/components/compound-components/common/uppy/uppy-uploader';
import UppyMediaManager from '@/components/compound-components/common/uppy/uppy-media-manager';
import { Media } from '@/__generated__/graphql';
import { cleanTypeName } from '@/lib/utils';

const BrandLogosFragment = gql(`
  fragment BrandLogosFragment on Organization {
    logos {
      url
      id
    }
  }
`);

const Logos = ({
  logos,
  onLogoChange,
}: {
  logos: FragmentType<typeof BrandLogosFragment>;
  onLogoChange: (logos: Media[] | null) => void;
}) => {
  const logosFragment = useFragment(BrandLogosFragment, logos);
  const [logoData, setLogoData] = useState(
    logosFragment?.logos.map((logo) => ({
      id: logo?.id,
      url: logo?.url,
    }))
  );
  const onUpload = async (fileId: string, previewUrl: string) => {
    const logos = logosFragment?.logos
      .filter((item) => item?.id !== fileId)
      .concat({ id: fileId, url: previewUrl });
    setLogoData(logos as Media[]);
    onLogoChange(cleanTypeName(logos));
  };

  const onDeleteLogo = async (fileId: string) => {
    const logos = logosFragment?.logos.filter((item) => item?.id !== fileId);
    setLogoData((media) => media.filter((item) => item?.id !== fileId));
    onLogoChange(cleanTypeName(logos));
  };

  return (
    <>
      <UppyMediaManager
        assetsType={AssetsType.logos}
        media={(logoData as Media[]) || []}
        onUpload={onUpload}
        onDelete={onDeleteLogo}
      />
    </>
  );
};

export default Logos;
